// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoticeIcon-module__font-s-10___Z30mz {
  font-size: 10px !important;
}

.NoticeIcon-module__font-s-12___iCS7O {
  font-size: 12px !important;
}

.NoticeIcon-module__font-s-13___mIyba {
  font-size: 13px !important;
}

.NoticeIcon-module__font-s-14___XH2lS {
  font-size: 14px !important;
}

.NoticeIcon-module__font-s-15___HxjWX {
  font-size: 15px !important;
}

.NoticeIcon-module__font-s-16___N2xHr {
  font-size: 16px !important;
}

.NoticeIcon-module__font-s-18___TTAtX {
  font-size: 18px !important;
}

.NoticeIcon-module__font-s-20___fCpDG {
  font-size: 20px !important;
}

.NoticeIcon-module__font-s-22___Pdfr2 {
  font-size: 22px !important;
}

.NoticeIcon-module__font-s-28___h2eqs {
  font-size: 28px !important;
}

.NoticeIcon-module__font-w-400___a1RLa {
  font-weight: 400 !important;
}

.NoticeIcon-module__font-w-500___RD9Aj {
  font-weight: 500 !important;
}

.NoticeIcon-module__font-w-600___jUhbE {
  font-weight: 600 !important;
}

.NoticeIcon-module__font-w-700___TMC8K {
  font-weight: 700 !important;
}

.NoticeIcon-module__p-5___Y3yur {
  padding: 5px !important;
}

.NoticeIcon-module__p-12___jecWo {
  padding: 12px !important;
}

.NoticeIcon-module__p-16___Z_Ddc {
  padding: 16px !important;
}

.NoticeIcon-module__p-30___o52Z5 {
  padding: 30px !important;
}

.NoticeIcon-module__p-b-0___LWZVK {
  padding-bottom: 0 !important;
}

.NoticeIcon-module__p-b-5___gcfnI {
  padding-bottom: 5px !important;
}

.NoticeIcon-module__p-b-10___c3oYa {
  padding-bottom: 10px !important;
}

.NoticeIcon-module__p-b-12___oHcEy {
  padding-bottom: 12px !important;
}

.NoticeIcon-module__p-b-16___LKseu {
  padding-bottom: 16px !important;
}

.NoticeIcon-module__p-b-18___rUeFb {
  padding-bottom: 18px !important;
}

.NoticeIcon-module__p-b-20___QItny {
  padding-bottom: 20px !important;
}

.NoticeIcon-module__p-b-25___C_SsR {
  padding-bottom: 25px !important;
}

.NoticeIcon-module__p-b-30___vg2Lw {
  padding-bottom: 30px !important;
}

.NoticeIcon-module__p-b-50___gyUIi {
  padding-bottom: 50px !important;
}

.NoticeIcon-module__p-t-0___Oy1_f {
  padding-top: 0 !important;
}

.NoticeIcon-module__p-t-12___ZlmDt {
  padding-top: 12px !important;
}

.NoticeIcon-module__p-t-16____e9XO {
  padding-top: 16px !important;
}

.NoticeIcon-module__p-t-18___zov8G {
  padding-top: 18px !important;
}

.NoticeIcon-module__p-t-20___m2QhI {
  padding-top: 20px !important;
}

.NoticeIcon-module__p-t-30___P7gPQ {
  padding-top: 30px !important;
}

.NoticeIcon-module__p-t-40___SixLQ {
  padding-top: 40px !important;
}

.NoticeIcon-module__p-t-50___FPCtL {
  padding-top: 50px !important;
}

.NoticeIcon-module__p-l-20___mtkU1 {
  padding-left: 20px !important;
}

.NoticeIcon-module__p-l-30___OqZU8 {
  padding-left: 30px !important;
}

.NoticeIcon-module__p-l-40___BqPou {
  padding-left: 40px !important;
}

.NoticeIcon-module__p-r-16___cZfPf {
  padding-right: 16px !important;
}

.NoticeIcon-module__p-r-20___XMIKm {
  padding-right: 20px !important;
}

.NoticeIcon-module__p-r-30___yzKz6 {
  padding-right: 30px !important;
}

.NoticeIcon-module__p-r-50___e3ZUy {
  padding-right: 50px !important;
}

.NoticeIcon-module__p-r-60___zd5hT {
  padding-right: 60px !important;
}

.NoticeIcon-module__m-b-1___Q_g6g {
  margin-bottom: 1px !important;
}

.NoticeIcon-module__m-b-2___OtPZj {
  margin-bottom: 2px !important;
}

.NoticeIcon-module__m-b-6___EM2IZ {
  margin-bottom: 6px !important;
}

.NoticeIcon-module__m-b-8___RxFpw {
  margin-bottom: 8px !important;
}

.NoticeIcon-module__m-b-10___YdKKz {
  margin-bottom: 10px !important;
}

.NoticeIcon-module__m-b-14___F3kSN {
  margin-bottom: 14px !important;
}

.NoticeIcon-module__m-b-16___Y9_OU {
  margin-bottom: 16px !important;
}

.NoticeIcon-module__m-b-20___hLIti {
  margin-bottom: 20px !important;
}

.NoticeIcon-module__m-b-22___bImcv {
  margin-bottom: 22px !important;
}

.NoticeIcon-module__m-b-24___pOQni {
  margin-bottom: 24px !important;
}

.NoticeIcon-module__m-b-30___Hymxf {
  margin-bottom: 30px !important;
}

.NoticeIcon-module__m-b-32___WDPTQ {
  margin-bottom: 32px !important;
}

.NoticeIcon-module__m-b-40___MscNf {
  margin-bottom: 40px !important;
}

.NoticeIcon-module__m-t-2___RRZIL {
  margin-top: 2px !important;
}

.NoticeIcon-module__m-t-3___UgHBp {
  margin-top: 3px !important;
}

.NoticeIcon-module__m-t-4___yxRZW {
  margin-top: 4px !important;
}

.NoticeIcon-module__m-t-5___wg6TQ {
  margin-top: 5px !important;
}

.NoticeIcon-module__m-t-8___NphmP {
  margin-top: 8px !important;
}

.NoticeIcon-module__m-t-10___VxcBC {
  margin-top: 10px !important;
}

.NoticeIcon-module__m-t-15___SNVEH {
  margin-top: 15px !important;
}

.NoticeIcon-module__m-t-16___mH4Fa {
  margin-top: 16px !important;
}

.NoticeIcon-module__m-t-20___Aan7s {
  margin-top: 20px !important;
}

.NoticeIcon-module__m-t-22___JCC73 {
  margin-top: 22px !important;
}

.NoticeIcon-module__m-t-30___m23xP {
  margin-top: 30px !important;
}

.NoticeIcon-module__m-t-32___In4fU {
  margin-top: 32px !important;
}

.NoticeIcon-module__m-l-auto___DpafY {
  margin-left: auto !important;
}

.NoticeIcon-module__m-l-4___Sp95Q {
  margin-left: 4px !important;
}

.NoticeIcon-module__m-l-5___lzeTH {
  margin-left: 5px !important;
}

.NoticeIcon-module__m-l-6___Gqgr4 {
  margin-left: 6px !important;
}

.NoticeIcon-module__m-l-8___WHLfo {
  margin-left: 8px !important;
}

.NoticeIcon-module__m-l-10___C5wgk {
  margin-left: 10px !important;
}

.NoticeIcon-module__m-l-16___ObAF9 {
  margin-left: 16px !important;
}

.NoticeIcon-module__m-l-20___Buoii {
  margin-left: 20px !important;
}

.NoticeIcon-module__m-l-24___hd59i {
  margin-left: 24px !important;
}

.NoticeIcon-module__m-l-30___OPOP3 {
  margin-left: 30px !important;
}

.NoticeIcon-module__m-l-35___urlNg {
  margin-left: 35px !important;
}

.NoticeIcon-module__m-l-40___TEiHw {
  margin-left: 40px !important;
}

.NoticeIcon-module__m-r-8___nXfJx {
  margin-right: 8px !important;
}

.NoticeIcon-module__m-r-10___pNoCS {
  margin-right: 10px !important;
}

.NoticeIcon-module__m-r-16___vX9iU {
  margin-right: 16px !important;
}

.NoticeIcon-module__m-r-20___acjks {
  margin-right: 20px !important;
}

.NoticeIcon-module__m-r-24___UDMQ8 {
  margin-right: 24px !important;
}

.NoticeIcon-module__m-r-30___bPLKt {
  margin-right: 30px !important;
}

.NoticeIcon-module__m-r-40___JZOPd {
  margin-right: 40px !important;
}

.NoticeIcon-module__border-r-3___zaoAJ {
  border-radius: 3px !important;
}

.NoticeIcon-module__border-r-4___CWppd {
  border-radius: 4px !important;
}

.NoticeIcon-module__border-r-6___gbZga {
  border-radius: 6px !important;
}

.NoticeIcon-module__border-r-10___PJpVd {
  border-radius: 10px !important;
}

.NoticeIcon-module__border-r-12___CC4GO {
  border-radius: 12px !important;
}

.NoticeIcon-module__border-r-16___F9nkA {
  border-radius: 16px !important;
}

.NoticeIcon-module__border-r-50___NhbIz {
  border-radius: 50% !important;
}

.NoticeIcon-module__primary-border___km7Zb {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.NoticeIcon-module__primary-border-b___kLfmE {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.NoticeIcon-module__primary-border-t___zMuX3 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.NoticeIcon-module__primary-border-l___u1S05 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.NoticeIcon-module__primary-border-r___qF6ZG {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.NoticeIcon-module__secondary-border___vR0C_ {
  border: 1px solid #637768;
}

.NoticeIcon-module__secondary-border-b___lLLPU {
  border-bottom: 1px solid #637768;
}

.NoticeIcon-module__secondary-border-t___xt_Yv {
  border-top: 1px solid #637768;
}

.NoticeIcon-module__secondary-border-l___Hmuaa {
  border-left: 1px solid #637768;
}

.NoticeIcon-module__secondary-border-r___H5vDh {
  border-right: 1px solid #637768;
}

.NoticeIcon-module__gap-0___kMFBe {
  gap: 0 !important;
}

.NoticeIcon-module__gap-2___NRo3X {
  gap: 2px !important;
}

.NoticeIcon-module__gap-4___vXvgx {
  gap: 4px !important;
}

.NoticeIcon-module__gap-5___fXdjC {
  gap: 5px !important;
}

.NoticeIcon-module__gap-6___bzjMI {
  gap: 6px !important;
}

.NoticeIcon-module__gap-8___lfohS {
  gap: 8px !important;
}

.NoticeIcon-module__gap-10___fQW4Z {
  gap: 10px !important;
}

.NoticeIcon-module__gap-12___jx4GQ {
  gap: 12px !important;
}

.NoticeIcon-module__gap-14___yh1Kt {
  gap: 14px !important;
}

.NoticeIcon-module__gap-16___xtScT {
  gap: 16px !important;
}

.NoticeIcon-module__gap-18___OweJP {
  gap: 18px !important;
}

.NoticeIcon-module__gap-20___qSYBL {
  gap: 20px !important;
}

.NoticeIcon-module__gap-24___BYiMp {
  gap: 24px !important;
}

.NoticeIcon-module__gap-26___J5dUh {
  gap: 26px !important;
}

.NoticeIcon-module__gap-30___Kulx4 {
  gap: 30px !important;
}

.NoticeIcon-module__gap-32___ItP0s {
  gap: 32px !important;
}

.NoticeIcon-module__gap-40___v8TuE {
  gap: 40px !important;
}

.NoticeIcon-module__gap-50___u96P7 {
  gap: 50px !important;
}

.NoticeIcon-module__flex-1___bTSQT {
  flex: 1;
}

.NoticeIcon-module__flex-none___g0mVO {
  flex: none !important;
}

.NoticeIcon-module__flex-column___ssp_h {
  display: flex;
  flex-direction: column !important;
}

.NoticeIcon-module__flex-row___gvSmk {
  display: flex;
  flex-direction: row !important;
}

.NoticeIcon-module__vertically-centered___ADcEc {
  display: flex;
  align-items: center !important;
}

.NoticeIcon-module__horizontally-centered___L5cIQ {
  display: flex;
  justify-content: center !important;
}

.NoticeIcon-module__horizontally-end___Gc1EW {
  display: flex;
  justify-content: end !important;
}

.NoticeIcon-module__vertically-start___x6fWa {
  display: flex;
  align-items: start !important;
}

.NoticeIcon-module__space-between___CbY_m {
  display: flex;
  justify-content: space-between !important;
}

.NoticeIcon-module__flex-wrap___cikHT {
  flex-wrap: wrap !important;
}

.NoticeIcon-module__height-100___pYdo1 {
  height: 100%;
}

.NoticeIcon-module__width-50___rPcj4 {
  width: 50% !important;
}

.NoticeIcon-module__width-100___c5JWB {
  width: 100%;
}

.NoticeIcon-module__cursor-pointer___WWPaU {
  cursor: pointer;
}

.NoticeIcon-module__cursor-not-allowed___A3qCr {
  cursor: not-allowed !important;
}

.NoticeIcon-module__absolute-centered___dFYE6 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.NoticeIcon-module__absolute___f9jcj {
  position: absolute;
}

.NoticeIcon-module__relative___HlPxk {
  position: relative;
}

.NoticeIcon-module__fixed___sAZaI {
  position: fixed;
}

.NoticeIcon-module__visible___RQ7i1 {
  opacity: 1;
}

.NoticeIcon-module__invisible___SB58I {
  opacity: 0;
}

.NoticeIcon-module__col-90___JlOmI {
  width: 90% !important;
}

.NoticeIcon-module__col-auto___ga6wk {
  width: auto !important;
}

.NoticeIcon-module__medical-tabs___BeBGV {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.NoticeIcon-module__medical-table-new___xxzUg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoticeIcon-module__medical-table-new___xxzUg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoticeIcon-module__medical-table-new___xxzUg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoticeIcon-module__medical-table-new___xxzUg::-webkit-scrollbar-track {
  display: none;
}
.NoticeIcon-module__medical-table-new___xxzUg.NoticeIcon-module__no-pagination___Q6u7t {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoticeIcon-module__medical-table-new___xxzUg.NoticeIcon-module__no-pagination___Q6u7t:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoticeIcon-module__medical-table-new___xxzUg.NoticeIcon-module__no-pagination___Q6u7t::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoticeIcon-module__medical-table-new___xxzUg.NoticeIcon-module__no-pagination___Q6u7t::-webkit-scrollbar-track {
  display: none;
}

.NoticeIcon-module__medical-table-empty___Aqqqx {
  padding: 14px 40px !important;
}

.NoticeIcon-module__icon-btn___XBu86 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.NoticeIcon-module__search-icon___DYhAg {
  width: 24px;
  height: 24px;
  align-self: center;
}

.NoticeIcon-module__disable-select___XvMKz {
  user-select: none;
}

.NoticeIcon-module__break-word___Mk2fp {
  word-break: break-word;
}

.NoticeIcon-module__popup-clear-btn___ImB8b {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.NoticeIcon-module__scroll-m-b-20___bPTW0 {
  scroll-margin-bottom: 20px;
}

.NoticeIcon-module__noticeIcon___StSKm {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.15s;
}

.NoticeIcon-module__neutral___JVFOA {
  background: #ffffff;
  border-color: #e4e4e7;
  color: #52525b;
}
.NoticeIcon-module__neutral___JVFOA:hover {
  border-color: #a1a1aa;
}

.NoticeIcon-module__warning___cWkaC {
  background: #fefce8;
  border-color: #fde68a;
  color: #854d0e;
}
.NoticeIcon-module__warning___cWkaC:hover {
  border-color: #854d0e;
}

.NoticeIcon-module__planned____cJYD {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}
.NoticeIcon-module__planned____cJYD:hover {
  border-color: #166534;
}

.NoticeIcon-module__alert___hDweK {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}
.NoticeIcon-module__alert___hDweK:hover {
  border-color: #991b1b;
}

.NoticeIcon-module__count___uqxCB {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 15px;
  padding: 0 4px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  font-weight: 600;
  line-height: 15px;
  text-align: center;
  color: #ffffff;
  background: #18181b;
  border-radius: 9999px;
}

.NoticeIcon-module__tip____jqh5 {
  position: fixed;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 280px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.4;
  color: #fafafa;
  background: #18181b;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.NoticeIcon-module__tipDetail___smHgb {
  color: #d4d4d8;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/NoticeIcon/NoticeIcon.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,qBAAA;AA8pBJ;;AA1pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA6pBF;AA3pBE;EACE,qBAAA;AA6pBJ;;AAzpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA4pBF;AA1pBE;EACE,qBAAA;AA4pBJ;;AAxpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA2pBF;AAzpBE;EACE,qBAAA;AA2pBJ;;AAvpBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AA0pBF;;AAvpBA;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,oBAAA;AA0pBF;;AAvpBA;EACE,cAAA;AA0pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.noticeIcon {\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 1px solid;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.15s;\n}\n\n.neutral {\n  background: tone-color(neutral, bg);\n  border-color: tone-color(neutral, border);\n  color: #52525b;\n\n  &:hover {\n    border-color: #a1a1aa;\n  }\n}\n\n.warning {\n  background: tone-color(warning, bg);\n  border-color: tone-color(warning, border);\n  color: tone-color(warning, text);\n\n  &:hover {\n    border-color: tone-color(warning, text);\n  }\n}\n\n.planned {\n  background: tone-color(success, bg);\n  border-color: tone-color(success, border);\n  color: tone-color(success, text);\n\n  &:hover {\n    border-color: tone-color(success, text);\n  }\n}\n\n.alert {\n  background: tone-color(danger, bg);\n  border-color: tone-color(danger, border);\n  color: tone-color(danger, text);\n\n  &:hover {\n    border-color: tone-color(danger, text);\n  }\n}\n\n.count {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 15px;\n  padding: 0 4px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 15px;\n  text-align: center;\n  color: #ffffff;\n  background: #18181b;\n  border-radius: 9999px;\n}\n\n.tip {\n  position: fixed;\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-width: 280px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #fafafa;\n  background: #18181b;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n}\n\n.tipDetail {\n  color: #d4d4d8;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `NoticeIcon-module__font-s-10___Z30mz`,
	"fontS12": `NoticeIcon-module__font-s-12___iCS7O`,
	"fontS13": `NoticeIcon-module__font-s-13___mIyba`,
	"fontS14": `NoticeIcon-module__font-s-14___XH2lS`,
	"fontS15": `NoticeIcon-module__font-s-15___HxjWX`,
	"fontS16": `NoticeIcon-module__font-s-16___N2xHr`,
	"fontS18": `NoticeIcon-module__font-s-18___TTAtX`,
	"fontS20": `NoticeIcon-module__font-s-20___fCpDG`,
	"fontS22": `NoticeIcon-module__font-s-22___Pdfr2`,
	"fontS28": `NoticeIcon-module__font-s-28___h2eqs`,
	"fontW400": `NoticeIcon-module__font-w-400___a1RLa`,
	"fontW500": `NoticeIcon-module__font-w-500___RD9Aj`,
	"fontW600": `NoticeIcon-module__font-w-600___jUhbE`,
	"fontW700": `NoticeIcon-module__font-w-700___TMC8K`,
	"p5": `NoticeIcon-module__p-5___Y3yur`,
	"p12": `NoticeIcon-module__p-12___jecWo`,
	"p16": `NoticeIcon-module__p-16___Z_Ddc`,
	"p30": `NoticeIcon-module__p-30___o52Z5`,
	"pB0": `NoticeIcon-module__p-b-0___LWZVK`,
	"pB5": `NoticeIcon-module__p-b-5___gcfnI`,
	"pB10": `NoticeIcon-module__p-b-10___c3oYa`,
	"pB12": `NoticeIcon-module__p-b-12___oHcEy`,
	"pB16": `NoticeIcon-module__p-b-16___LKseu`,
	"pB18": `NoticeIcon-module__p-b-18___rUeFb`,
	"pB20": `NoticeIcon-module__p-b-20___QItny`,
	"pB25": `NoticeIcon-module__p-b-25___C_SsR`,
	"pB30": `NoticeIcon-module__p-b-30___vg2Lw`,
	"pB50": `NoticeIcon-module__p-b-50___gyUIi`,
	"pT0": `NoticeIcon-module__p-t-0___Oy1_f`,
	"pT12": `NoticeIcon-module__p-t-12___ZlmDt`,
	"pT16": `NoticeIcon-module__p-t-16____e9XO`,
	"pT18": `NoticeIcon-module__p-t-18___zov8G`,
	"pT20": `NoticeIcon-module__p-t-20___m2QhI`,
	"pT30": `NoticeIcon-module__p-t-30___P7gPQ`,
	"pT40": `NoticeIcon-module__p-t-40___SixLQ`,
	"pT50": `NoticeIcon-module__p-t-50___FPCtL`,
	"pL20": `NoticeIcon-module__p-l-20___mtkU1`,
	"pL30": `NoticeIcon-module__p-l-30___OqZU8`,
	"pL40": `NoticeIcon-module__p-l-40___BqPou`,
	"pR16": `NoticeIcon-module__p-r-16___cZfPf`,
	"pR20": `NoticeIcon-module__p-r-20___XMIKm`,
	"pR30": `NoticeIcon-module__p-r-30___yzKz6`,
	"pR50": `NoticeIcon-module__p-r-50___e3ZUy`,
	"pR60": `NoticeIcon-module__p-r-60___zd5hT`,
	"mB1": `NoticeIcon-module__m-b-1___Q_g6g`,
	"mB2": `NoticeIcon-module__m-b-2___OtPZj`,
	"mB6": `NoticeIcon-module__m-b-6___EM2IZ`,
	"mB8": `NoticeIcon-module__m-b-8___RxFpw`,
	"mB10": `NoticeIcon-module__m-b-10___YdKKz`,
	"mB14": `NoticeIcon-module__m-b-14___F3kSN`,
	"mB16": `NoticeIcon-module__m-b-16___Y9_OU`,
	"mB20": `NoticeIcon-module__m-b-20___hLIti`,
	"mB22": `NoticeIcon-module__m-b-22___bImcv`,
	"mB24": `NoticeIcon-module__m-b-24___pOQni`,
	"mB30": `NoticeIcon-module__m-b-30___Hymxf`,
	"mB32": `NoticeIcon-module__m-b-32___WDPTQ`,
	"mB40": `NoticeIcon-module__m-b-40___MscNf`,
	"mT2": `NoticeIcon-module__m-t-2___RRZIL`,
	"mT3": `NoticeIcon-module__m-t-3___UgHBp`,
	"mT4": `NoticeIcon-module__m-t-4___yxRZW`,
	"mT5": `NoticeIcon-module__m-t-5___wg6TQ`,
	"mT8": `NoticeIcon-module__m-t-8___NphmP`,
	"mT10": `NoticeIcon-module__m-t-10___VxcBC`,
	"mT15": `NoticeIcon-module__m-t-15___SNVEH`,
	"mT16": `NoticeIcon-module__m-t-16___mH4Fa`,
	"mT20": `NoticeIcon-module__m-t-20___Aan7s`,
	"mT22": `NoticeIcon-module__m-t-22___JCC73`,
	"mT30": `NoticeIcon-module__m-t-30___m23xP`,
	"mT32": `NoticeIcon-module__m-t-32___In4fU`,
	"mLAuto": `NoticeIcon-module__m-l-auto___DpafY`,
	"mL4": `NoticeIcon-module__m-l-4___Sp95Q`,
	"mL5": `NoticeIcon-module__m-l-5___lzeTH`,
	"mL6": `NoticeIcon-module__m-l-6___Gqgr4`,
	"mL8": `NoticeIcon-module__m-l-8___WHLfo`,
	"mL10": `NoticeIcon-module__m-l-10___C5wgk`,
	"mL16": `NoticeIcon-module__m-l-16___ObAF9`,
	"mL20": `NoticeIcon-module__m-l-20___Buoii`,
	"mL24": `NoticeIcon-module__m-l-24___hd59i`,
	"mL30": `NoticeIcon-module__m-l-30___OPOP3`,
	"mL35": `NoticeIcon-module__m-l-35___urlNg`,
	"mL40": `NoticeIcon-module__m-l-40___TEiHw`,
	"mR8": `NoticeIcon-module__m-r-8___nXfJx`,
	"mR10": `NoticeIcon-module__m-r-10___pNoCS`,
	"mR16": `NoticeIcon-module__m-r-16___vX9iU`,
	"mR20": `NoticeIcon-module__m-r-20___acjks`,
	"mR24": `NoticeIcon-module__m-r-24___UDMQ8`,
	"mR30": `NoticeIcon-module__m-r-30___bPLKt`,
	"mR40": `NoticeIcon-module__m-r-40___JZOPd`,
	"borderR3": `NoticeIcon-module__border-r-3___zaoAJ`,
	"borderR4": `NoticeIcon-module__border-r-4___CWppd`,
	"borderR6": `NoticeIcon-module__border-r-6___gbZga`,
	"borderR10": `NoticeIcon-module__border-r-10___PJpVd`,
	"borderR12": `NoticeIcon-module__border-r-12___CC4GO`,
	"borderR16": `NoticeIcon-module__border-r-16___F9nkA`,
	"borderR50": `NoticeIcon-module__border-r-50___NhbIz`,
	"primaryBorder": `NoticeIcon-module__primary-border___km7Zb`,
	"primaryBorderB": `NoticeIcon-module__primary-border-b___kLfmE`,
	"primaryBorderT": `NoticeIcon-module__primary-border-t___zMuX3`,
	"primaryBorderL": `NoticeIcon-module__primary-border-l___u1S05`,
	"primaryBorderR": `NoticeIcon-module__primary-border-r___qF6ZG`,
	"secondaryBorder": `NoticeIcon-module__secondary-border___vR0C_`,
	"secondaryBorderB": `NoticeIcon-module__secondary-border-b___lLLPU`,
	"secondaryBorderT": `NoticeIcon-module__secondary-border-t___xt_Yv`,
	"secondaryBorderL": `NoticeIcon-module__secondary-border-l___Hmuaa`,
	"secondaryBorderR": `NoticeIcon-module__secondary-border-r___H5vDh`,
	"gap0": `NoticeIcon-module__gap-0___kMFBe`,
	"gap2": `NoticeIcon-module__gap-2___NRo3X`,
	"gap4": `NoticeIcon-module__gap-4___vXvgx`,
	"gap5": `NoticeIcon-module__gap-5___fXdjC`,
	"gap6": `NoticeIcon-module__gap-6___bzjMI`,
	"gap8": `NoticeIcon-module__gap-8___lfohS`,
	"gap10": `NoticeIcon-module__gap-10___fQW4Z`,
	"gap12": `NoticeIcon-module__gap-12___jx4GQ`,
	"gap14": `NoticeIcon-module__gap-14___yh1Kt`,
	"gap16": `NoticeIcon-module__gap-16___xtScT`,
	"gap18": `NoticeIcon-module__gap-18___OweJP`,
	"gap20": `NoticeIcon-module__gap-20___qSYBL`,
	"gap24": `NoticeIcon-module__gap-24___BYiMp`,
	"gap26": `NoticeIcon-module__gap-26___J5dUh`,
	"gap30": `NoticeIcon-module__gap-30___Kulx4`,
	"gap32": `NoticeIcon-module__gap-32___ItP0s`,
	"gap40": `NoticeIcon-module__gap-40___v8TuE`,
	"gap50": `NoticeIcon-module__gap-50___u96P7`,
	"flex1": `NoticeIcon-module__flex-1___bTSQT`,
	"flexNone": `NoticeIcon-module__flex-none___g0mVO`,
	"flexColumn": `NoticeIcon-module__flex-column___ssp_h`,
	"flexRow": `NoticeIcon-module__flex-row___gvSmk`,
	"verticallyCentered": `NoticeIcon-module__vertically-centered___ADcEc`,
	"horizontallyCentered": `NoticeIcon-module__horizontally-centered___L5cIQ`,
	"horizontallyEnd": `NoticeIcon-module__horizontally-end___Gc1EW`,
	"verticallyStart": `NoticeIcon-module__vertically-start___x6fWa`,
	"spaceBetween": `NoticeIcon-module__space-between___CbY_m`,
	"flexWrap": `NoticeIcon-module__flex-wrap___cikHT`,
	"height100": `NoticeIcon-module__height-100___pYdo1`,
	"width50": `NoticeIcon-module__width-50___rPcj4`,
	"width100": `NoticeIcon-module__width-100___c5JWB`,
	"cursorPointer": `NoticeIcon-module__cursor-pointer___WWPaU`,
	"cursorNotAllowed": `NoticeIcon-module__cursor-not-allowed___A3qCr`,
	"absoluteCentered": `NoticeIcon-module__absolute-centered___dFYE6`,
	"absolute": `NoticeIcon-module__absolute___f9jcj`,
	"relative": `NoticeIcon-module__relative___HlPxk`,
	"fixed": `NoticeIcon-module__fixed___sAZaI`,
	"visible": `NoticeIcon-module__visible___RQ7i1`,
	"invisible": `NoticeIcon-module__invisible___SB58I`,
	"col90": `NoticeIcon-module__col-90___JlOmI`,
	"colAuto": `NoticeIcon-module__col-auto___ga6wk`,
	"medicalTabs": `NoticeIcon-module__medical-tabs___BeBGV`,
	"medicalTableNew": `NoticeIcon-module__medical-table-new___xxzUg`,
	"noPagination": `NoticeIcon-module__no-pagination___Q6u7t`,
	"medicalTableEmpty": `NoticeIcon-module__medical-table-empty___Aqqqx`,
	"iconBtn": `NoticeIcon-module__icon-btn___XBu86`,
	"searchIcon": `NoticeIcon-module__search-icon___DYhAg`,
	"disableSelect": `NoticeIcon-module__disable-select___XvMKz`,
	"breakWord": `NoticeIcon-module__break-word___Mk2fp`,
	"popupClearBtn": `NoticeIcon-module__popup-clear-btn___ImB8b`,
	"scrollMB20": `NoticeIcon-module__scroll-m-b-20___bPTW0`,
	"noticeIcon": `NoticeIcon-module__noticeIcon___StSKm`,
	"neutral": `NoticeIcon-module__neutral___JVFOA`,
	"warning": `NoticeIcon-module__warning___cWkaC`,
	"planned": `NoticeIcon-module__planned____cJYD`,
	"alert": `NoticeIcon-module__alert___hDweK`,
	"count": `NoticeIcon-module__count___uqxCB`,
	"tip": `NoticeIcon-module__tip____jqh5`,
	"tipDetail": `NoticeIcon-module__tipDetail___smHgb`
};
module.exports = ___CSS_LOADER_EXPORT___;
